// extracted by mini-css-extract-plugin
export var appleCheckout = "ExternalPayForm-module__appleCheckout___dDFy3";
export var applePayIcon = "ExternalPayForm-module__applePayIcon___ktWTX";
export var contents = "ExternalPayForm-module__contents___swVEv";
export var payPalCheckout = "ExternalPayForm-module__payPalCheckout___VWBRA";
export var payPalIcon = "ExternalPayForm-module__payPalIcon___kjFMX";